import {GoogleMap, LoadScript, Marker} from '@react-google-maps/api';
import PropTypes from 'prop-types';

const containerStyle = {
  width: '100%',
  height: '60vh',
  marginTop: '10px',
};

const center = {lat: 46.8182, lng: 8.2275};

const createKey = (location) => location._lat + location._long;

const EdgeMap = ({edgeData}) => (
  <LoadScript googleMapsApiKey="AIzaSyAMOKqlaiYfsLSwE6GZ__ZUnNacXjClT1g" mapIds={['e36a52774f68c5c7']}>
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      options={{mapId: 'e36a52774f68c5c7'}}
      zoom={8}
    >
      {edgeData?.map(
        (eD) =>
          eD.geolocation && (
            <Marker
              key={createKey(eD.geolocation)}
              position={{lat: eD.geolocation._lat, lng: eD.geolocation._long}}
            />
          )
      )}
    </GoogleMap>
  </LoadScript>
);

EdgeMap.propTypes = {
  edgeData: PropTypes.array.isRequired,
};

export default EdgeMap;
